import React, { createContext, useContext, useEffect, useState } from "react";
import { getLoggedInUser } from "../api/auth.api";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchUser = async () => {
    try {

      const data = await getLoggedInUser();

      if (data) {
        setUser(data);
      } else {
        setUser(null);
      }

    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {

    fetchUser();

    window.addEventListener("loginSuccess", fetchUser);

    return () => {
      window.removeEventListener("loginSuccess", fetchUser);
    };

  }, []);

  return (
    <AuthContext.Provider
      value={{
        user,
        setUser,
        loading,
        fetchUser
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);